module.exports = __webpack_public_path__ + "img/thomas-plauder.a20225e1.jpg";